import { combineReducers } from 'redux';
import {createResponsiveStateReducer} from 'redux-responsive'

import timeline from './timeline';
import video from './video';
import about from './about';
import maps from './maps';

const rootReducer = combineReducers({
    timeline,
    video,
    about,
    maps,
    responsive: createResponsiveStateReducer({
        mobile: 650,
        tablet: 750,
        desktop: 1200
    })
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/state/reducers/index.js